@use "@fukuri-admins/ui/layout" as *;

.SideMenuHeader {
  padding: 40px 16px;
  text-align: center;
  @media screen and (max-width: $TB) {
    margin-bottom: 0;
  }

  img {
    max-width: 200px;
    max-height: 80px;
    @media screen and (max-width: $TB) {
      margin-bottom: 0;
      max-width: 120px;
    }
  }
}
